import React, { Component, CSSProperties } from 'react';
import { Grid, Typography, Button, CircularProgress, Slide, IconButton } from '@material-ui/core';
import { SignUpProps } from '../../connected/SignUpCnn';
import { withRouter } from 'react-router';
import BusinessInformationForm from './BusinessInformationForm';
import UserInformationForm from './UserInformationForm';
import RestaurantInformationForm from './RestaurantInformationForm';
import { Restaurant } from '../../../api/models/RestaurantData';
import { Business } from '../../../api/models/BusinessData';
import restaurantImg from '../../../scss/img/restaurant.png'
import supplierImg from '../../../scss/img/supplier.png'
import LogoAndTitle from '../../../Layout/components/LogoAndTitle';
import { Supplier } from '../../../api/models/QuotedData';
import SupplierInformationForm from './SupplierInformationForm';
import { ArrowBack } from '@material-ui/icons';
import { Credentials } from '../../../api/models/Credentials';


type State = {
    restaurant: Restaurant | null,
    supplier: Supplier | null,
    business: Business | null,
    registerSubject: "supplier" | "restaurant" | null,
    currentStep: number,
    in: boolean,
    userFormValid: boolean
}

const imageStyle: CSSProperties = {
    width: "100%",
    borderRadius: "20px"
}


//We are triggering the other setState to let animation load properly
const steps: any =
{
    0: {
        title: "What's your business?",
        subtitle: "Select which business you represent.",
        content: (cmpnnt: Component<SignUpProps, State>) => {
            return (
                <Grid container>
                    <Grid item sm={6} style={{ padding: "21px" }}>
                        <SubjectImage text="Restaurant" imgSrc={restaurantImg} onClick={() => cmpnnt.setState({ registerSubject: "restaurant", in: false }, () => cmpnnt.setState({ currentStep: 1, in: true }))} />
                    </Grid>
                    <Grid item sm={6} style={{ padding: "21px" }}>
                        <SubjectImage text="Supplier" imgSrc={supplierImg} onClick={() => cmpnnt.setState({ registerSubject: "supplier", in: false }, () => cmpnnt.setState({ currentStep: 1, in: true }))} />
                    </Grid>
                </Grid>
            )
        }
    },
    1: {
        title: "Company details",
        subtitle: "Fill your ABN number below.",
        content: (cmpnnt: Component<SignUpProps, State>) => {
            return (
                <BusinessInformationForm
                    update={(b: Business) => cmpnnt.setState({ business: b, in: false }, () => cmpnnt.setState({ currentStep: (cmpnnt.state.registerSubject === "restaurant" ? 2 : 3), in: true }))}
                    isAbnLookupBusy={cmpnnt.props.isAbnLookupBusy}
                    abnLookup={cmpnnt.props.abnLookup}
                    abnLookupResult={cmpnnt.props.abnLookupResult} />
            )
        }
    },
    2: {
        title: "Restaurant details",
        subtitle: "Fill your Restaurant details below.",
        content: (cmpnnt: Component<SignUpProps, State>) => {
            return (
                <RestaurantInformationForm
                    update={(r: Restaurant) => cmpnnt.setState({ restaurant: r }, () => cmpnnt.setState({ currentStep: 4, in: true }))}
                    chosenBusinessName={cmpnnt.state.business!.chosenBusinessName}
                    updateSignUpData={(r: Restaurant) => cmpnnt.setState({ restaurant: r }, () => cmpnnt.props.updateSignUpData(cmpnnt.state.restaurant))}
                    signUpData={cmpnnt.props.signUpData} />
            )
        }
    },
    3: {
        title: "Supplier details",
        subtitle: "Fill your details below.",
        content: (cmpnnt: Component<SignUpProps, State>) => {
            return (
                <SupplierInformationForm
                    update={(s: Supplier) => cmpnnt.setState({ supplier: s }, () => cmpnnt.setState({ currentStep: 4, in: true }))}
                    chosenBusinessName={cmpnnt.state.business!.chosenBusinessName}
                    updateSignUpData={(s: Supplier) => cmpnnt.setState({ supplier: s }, () => cmpnnt.props.updateSignUpData(cmpnnt.state.supplier))}
                    signUpData={cmpnnt.props.signUpData} />
            )
        }
    },
    4: {
        title: "User details",
        subtitle: "Setup your email and password.",
        content: (cmpnnt: SignUpForm) => {
            return (
                <UserInformationForm
                    update={(isValid: boolean) => { cmpnnt.setState({ userFormValid: isValid }) }}
                    ref={(usrForm) => {
                        cmpnnt.userFormRef = usrForm
                    }} />
            )
        }
    }
}

class SignUpForm extends Component<SignUpProps, State> {
    public userFormRef: UserInformationForm | null = null
    constructor(props: SignUpProps) {
        super(props)

        this.state = {
            restaurant: null,
            business: null,
            supplier: null,
            userFormValid: false,
            registerSubject: null,
            currentStep: 0,
            in: true
        }
    }

    componentDidMount() {
        this.props.resetSignUpForm()
    }
    componentDidUpdate(prevProps: SignUpProps, prevState: State) {
        if (prevProps.accountCreatedSuccesfully === null && this.props.accountCreatedSuccesfully === true)
            this.props.history.push('/')
    }


    reduceStep = () => {
        let stepToLoad = 0
        if (this.state.currentStep === 4) {
            if (this.state.registerSubject === "restaurant")
                stepToLoad = 2
            else
                stepToLoad = 3
        }
        else if (this.state.currentStep === 3)
            stepToLoad = 1
        else if (this.state.currentStep === 0) {
            this.props.history.push('/')
            return
        }
        else stepToLoad = this.state.currentStep - 1

        this.setState({ currentStep: stepToLoad })
    }


    render() {
        return (
            <div>
                <Grid container alignItems="center" alignContent="center">
                    <Grid item sm={1} style={{ textAlign: 'center' }}>
                        {this.state.currentStep >= 0 &&
                            <IconButton size="medium" onClick={() => this.reduceStep()}><ArrowBack fontSize="large" /></IconButton>
                        }
                    </Grid>
                    <Grid item sm={11}>
                        <LogoAndTitle title={steps[this.state.currentStep].title} subtitle={steps[this.state.currentStep].subtitle} />
                    </Grid>
                </Grid>
                {this.props.isBusy ?
                    <div style={{ textAlign: 'center' }} >
                        <CircularProgress size={50} />
                    </div>
                    :
                    <div>
                        <Slide direction="left" in={this.state.in}>
                            {steps[this.state.currentStep].content(this)}
                        </Slide>
                    </div>
                }
                {this.props.isBusy === false && this.state.currentStep === Object.keys(steps).length - 1 &&
                    <Grid container>
                        <Grid item sm={3} md={4}></Grid>
                        <Grid item xs={12} sm={6} md={4} style={{ paddingTop: '15px' }}>
                            <Button
                                disabled={this.userFormRef === null || !this.state.userFormValid || this.state.business === null || (this.state.restaurant === null && this.state.supplier === null)}
                                style={{ width: '100%' }} variant="contained" color="primary"
                                onClick={(e) => {
                                    var credentials: Credentials = {
                                        email: this.userFormRef!.state.email,
                                        password: this.userFormRef!.state.password,
                                        contactPersonName: this.userFormRef!.state.contactPersonName,
                                        contactPersonSurname: this.userFormRef!.state.contactPersonSurname
                                    }

                                    if (this.state.registerSubject! === "restaurant")
                                        this.props.signUpAndRegisterRestaurant(credentials, this.state.business, this.state.restaurant)
                                    else if (this.state.registerSubject! === "supplier")
                                        this.props.signUpAndRegisterSupplier(credentials, this.state.business, this.state.supplier)
                                    else throw new Error("There was a problem during your registration attempt, please contact QuoteMyOrder administrator.")
                                }}>Sign up</Button>
                        </Grid>
                        <Grid item sm={3} md={4}></Grid>
                    </Grid>
                }
            </div>
        );
    }

}

type ScProps = {
    text: string,
    imgSrc: string,
    onClick: (e: any) => void
}

class SubjectImage extends React.PureComponent<ScProps> {
    render() {
        const { text, imgSrc, onClick } = this.props;

        return (
            <div style={Object.assign({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                position: 'relative',
                cursor: 'pointer'

            })}
                onClick={onClick}
            >
                <img alt="" style={Object.assign({}, { flexShrink: 0, maxWidth: '100%', maxHeight: '100%' }, imageStyle)} src={imgSrc} />
                <div style={{ position: 'absolute', bottom: "0", width: "100%", backgroundColor: "rgb(255, 255, 255, 0.8)", textAlign: 'center', padding: '10px' }}>
                    <Grid container alignItems="center">
                        <Grid item xs={12} sm={12}>
                            <Typography variant='h2'>{text}</Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>

        )
    }
}

export default withRouter(SignUpForm);
